export const S3_BUCKET_REGION = "us-west-2";
export const S3_PDB_BUCKET_NAME = "rcsb-production-weekly-dataset-a";
export const S3_EMDB_BUCKET_NAME = "rcsb-production-emdb-a";
